export default __webpack_public_path__ + "d9074820d3d62949b96fc3bb493ebe33.svg";